// extracted by mini-css-extract-plugin
export default {"root":"hJdGpebUGb0hhWDamY6O","wrap":"aggZg5ymllRKqnvf8Ujw"};